import { useRequest } from 'ahooks'
import { getTokenDepositConfig } from '@/api/network'

const useTokenDepositConfig = () => {
  return useRequest(
    async () => {
      const resp = await getTokenDepositConfig()
      return resp.para.data
    },
    {
      cacheKey: 'TokenDepositConfig',
    },
  )
}

export default useTokenDepositConfig
